import './vendor/jquery-global';
import './vendor/antd/antd.css';

import $ from 'jquery';
import moment from 'moment';
window.moment = moment;

import 'jquery-migrate';
import 'jquery.browser';
import 'jquery-ui-dist/jquery-ui.min.js';
import './vendor/jquery-ui/jquery-ui.css';
import './vendor/jquery-ui/adjustments.css';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'moment/min/locales';

import datepickerDe from './vendor/jquery-ui/datepicker/i18n/datepicker-de';
datepickerDe($.datepicker);
import datepickerEs from './vendor/jquery-ui/datepicker/i18n/datepicker-es';
datepickerEs($.datepicker);
import datepickerFr from './vendor/jquery-ui/datepicker/i18n/datepicker-fr';
datepickerFr($.datepicker);
import datepickerIt from './vendor/jquery-ui/datepicker/i18n/datepicker-it';
datepickerIt($.datepicker);
import datepickerPt from './vendor/jquery-ui/datepicker/i18n/datepicker-pt';
datepickerPt($.datepicker);

import 'jquery-blockui';
import 'free-jqgrid/js/jquery.jqgrid.min.js';
import 'free-jqgrid/js/i18n/grid.locale-en.js';
import 'free-jqgrid/css/ui.jqgrid.css';
import './vendor/jqgrid/adjustments.css';
